<div class="day-container" *ngIf="day">
  <div class="day-container-desktop">
    <div class="day-label">{{ day.dayLabel }}</div>
  </div>
</div>
